import { render, staticRenderFns } from "./numeric.vue?vue&type=template&id=05613852"
import script from "./numeric.vue?vue&type=script&lang=js"
export * from "./numeric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports